import { Grid } from '@mui/material'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { allAvailableEventTypes } from 'src/consumer/constants'
import {
  GenericModalHeadlineLevelTwo,
  StyledEventInputContainer,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import { StyledPanelMemberReactSelect } from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'

export default function PanelAndWebinarConfig({
  basicEventObject,
  setBasicEventObject,
  selectedPanelMembers,
  handleMultiSelectPanelMembersChange,
  loadOptions,
  isDisabled,
}) {
  return (
    <>
        <div>
          {/* Phase 14az — relabelled "Interview Panel Members" → "Panel Members". The
              picker also serves consultations and clinic events, so the "Interview"
              qualifier was misleading. The loadOptions pipeline (in EventTypeCreationForm)
              now scopes to practitioners attached to this event's clinic location when
              one is set on the event object — so a clinic event's panel can only include
              people who actually work at that clinic. */}
          <GenericModalHeadlineLevelTwo>Panel Members</GenericModalHeadlineLevelTwo>
          <StyledPanelMemberReactSelect
            isMulti
            value={selectedPanelMembers}
            loadOptions={loadOptions}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            onChange={handleMultiSelectPanelMembersChange}
            debounceTimeout={500}
            isDisabled={isDisabled}
            additional={{
              page: 1,
            }}
          />
        </div>

      {basicEventObject?.type === allAvailableEventTypes?.webinar && (
        <div>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <CustomInput
                id="minUsers"
                label={'Minimum Users'}
                value={basicEventObject?.minUsers || ''}
                inputAndMessageContainer={StyledEventInputContainer}
                placeholder="Enter the minimum users in this webinar..."
                type="number"
                isDisabled={isDisabled}
                onChange={(e) => {
                  console.log(e.target.value)
                  const inputValue = Math.max(0, parseInt(e.target.value))
                  setBasicEventObject((prev) => ({
                    ...prev,
                    minUsers: inputValue,
                  }))
                }}
                disabled={!!basicEventObject?.contextId}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomInput
                id="maxUsers"
                label={'Maximum Users'}
                value={basicEventObject?.maxUsers || ''}
                inputAndMessageContainer={StyledEventInputContainer}
                placeholder="Enter the maximum users in this webinar..."
                type="number"
                onChange={(e) => {
                  console.log(e.target.value)
                  const inputValue = Math.max(0, parseInt(e.target.value))
                  setBasicEventObject((prev) => ({
                    ...prev,
                    maxUsers: inputValue,
                  }))
                }}
                disabled={isDisabled || !!basicEventObject?.contextId}
                required
              />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  )
}
